
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { IRewardData, notify, TRewardActionType } from "@housebets/housebets-x-package";
import { IVipReload } from "@housebets/housebets-x-package/lib/components/feature/rewards/VipReload/types";
import { useLangNavigate } from "app/hooks/useLangNavigate";
import { useIntl } from "react-intl";

export const useRewardDropdownData = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [rewardStep, setRewardStep] = useState<TRewardActionType | 'list'>(
        'list',
    );
    const [rewardSelectedData, setRewardSelectedData] = useState<
        IRewardData | IVipReload | null
    >(null);
    const navigate = useNavigate();
    const location = useLocation();
    const langNavigate = useLangNavigate();
    const {$t} = useIntl();

    const vipReloadTitles: {
        [key in TRewardActionType]: string;
    } = {
        vip_reload: $t({id: "VIPReload"}),
        instant_rakeback: $t({id: "benefits.bronze.instantRakeback.title"}),
        daily_reload: $t({id: "vipLevels.daily.title"}),
        weekly_reload: $t({id: "WeeklyReload"}),
        monthly_reload: $t({id: "MonthlyReload"}),
        level_up: $t({id: "LevelUp"}),
    };


    const showMessage = (step: TRewardActionType) => {
        notify({
            type: 'success',
            title: (
                <>
                    {$t({id: "Successfully.claimed"})}{" "}
                    <span
                        style={{
                            color: 'orange',
                        }}
                    >
                        {vipReloadTitles[step]}
                    </span>
                </>
            ),
        });
    };

    const onDashboardClick = () => {
        setIsOpen(false);
        navigate(langNavigate('/vip'));
    }

    useEffect(() => {
        setIsOpen(false);
    }, [location])

    return {
        isOpen,
        setIsOpen,
        rewardStep,
        setRewardStep,
        rewardSelectedData,
        setRewardSelectedData,
        showMessage,
        onDashboardClick,
    }
}